import { useState } from 'react'

import { Button, EmptyState, Layout, Link, Text } from '@loadsmart/loadsmart-ui'

import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { type BulkRate } from '../../domain/BulkRate'
import { type SortBy } from '../../domain/SortBy'
import { BulkSpotQuoteRates } from './BulkSpotQuoteRates'
import { BulkSpotQuoteTabHeader } from './BulkSpotQuoteTabHeader'

export type BulkSpotQuoteTabProps = {
  header: string
  emptyMessage: string
  rates: Array<BulkRate>
  onGoToPendingTab: () => void
}

export function BulkSpotQuoteTab({
  header,
  emptyMessage,
  rates,
  onGoToPendingTab,
}: BulkSpotQuoteTabProps) {
  const [sortBy, setSortBy] = useState<SortBy>('deadline')

  function handleCheckPendingTab(event: React.MouseEvent) {
    event.preventDefault()

    onGoToPendingTab()
  }

  if (rates.length === 0) {
    return (
      <Layout.Stack align="center">
        <EmptyState
          illustration={IllustrationDepartingTruck}
          title={emptyMessage}
          variant="panel"
        />
        <Layout.Stack space="xs" align="center">
          <Text as="div">
            {'Go to '}
            <Link href="#" onClick={handleCheckPendingTab}>
              pending tab
            </Link>
            {' to send your rates or go to our carrier'}
          </Text>
          <Text as="div">platform and find spot loads to keep your truck full</Text>
        </Layout.Stack>
        <Button type="button" variant="primary" onClick={handleCheckPendingTab}>
          check pending quotes
        </Button>
      </Layout.Stack>
    )
  }

  return (
    <Layout.Stack>
      <BulkSpotQuoteTabHeader
        header={header}
        sortBy={sortBy}
        onSortChange={value => setSortBy(value)}
      />
      <BulkSpotQuoteRates rates={rates} sortBy={sortBy} />
    </Layout.Stack>
  )
}
